var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop3 = function SvgTop3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "M18.786 1.151 22.09 11.26l25.676 44.394 10.167-5.406L35.348 4.21l-4.553-9.734-12.01 6.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.348-2.229 10.305-5.48 30.788 57.904-10.306 5.48L5.348-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "M62.31-.718 52.141-6.125 22.363 49.881l10.168 5.406 25.32-43.728L62.31-.718Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m64.227-7.14 10.305 5.48-30.51 57.382-10.307-5.48L64.227-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19B5E",
    d: "M40.031 26.672 38.36 57.344l1.672 30c16.735 0 30.344-13.61 30.344-30.344-.016-16.719-13.625-30.328-30.344-30.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19B5E",
    d: "M9.688 57c0 16.734 13.609 30.344 30.343 30.344V26.672C23.297 26.672 9.688 40.282 9.688 57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8348",
    d: "M40.031 31.36 38.36 57.343l1.672 25.312c14.14 0 25.657-11.5 25.657-25.656-.016-14.14-11.516-25.64-25.657-25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8348",
    d: "M14.375 57c0 14.14 11.5 25.656 25.656 25.656V31.36c-14.156 0-25.656 11.5-25.656 25.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.39 67.797 2.704-3.64c1.718 1.687 3.843 2.984 6.468 2.984 2.938 0 4.938-1.454 4.938-4.047 0-2.86-1.688-4.625-8-4.625v-4.157c5.328 0 7.063-1.843 7.063-4.437 0-2.281-1.407-3.61-3.876-3.64-2.078.046-3.765 1.015-5.484 2.593l-2.937-3.531c2.515-2.203 5.297-3.563 8.703-3.563 5.61 0 9.406 2.75 9.406 7.72 0 3.14-1.766 5.405-4.86 6.624v.203c3.297.907 5.797 3.328 5.797 7.14 0 5.329-4.671 8.438-10.203 8.438-4.578-.015-7.672-1.75-9.718-4.062Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v87.5H0z"
  })))));
};
export default SvgTop3;